export default __webpack_public_path__ + "img/jtc/jtc7_700.webp";